import { render, staticRenderFns } from "./singleText.vue?vue&type=template&id=1ea7c486&scoped=true&"
import script from "./singleText.vue?vue&type=script&lang=js&"
export * from "./singleText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea7c486",
  null
  
)

export default component.exports